import { BrowserRouter, Route, Routes } from "react-router-dom";
import RouteScrollToTop from "./helper/RouteScrollToTop";
import ShopPage from "./pages/ShopPage";
import ProductDetailsPageOne from "./pages/ProductDetailsPageOne";
import ProductDetailsPageTwo from "./pages/ProductDetailsPageTwo";
import CartPage from "./pages/CartPage";
import CheckoutPage from "./pages/CheckoutPage";
import AccountPage from "./pages/AccountPage";
import BlogPage from "./pages/BlogPage";
import BlogDetailsPage from "./pages/BlogDetailsPage";
import ContactPage from "./pages/ContactPage";
import PhosphorIconInit from "./helper/PhosphorIconInit";
import VendorPage from "./pages/VendorPage";
import VendorDetailsPage from "./pages/VendorDetailsPage";
import VendorTwoPage from "./pages/VendorTwoPage";
import VendorTwoDetailsPage from "./pages/VendorTwoDetailsPage";
import BecomeSellerPage from "./pages/BecomeSellerPage";
import WishlistPage from "./pages/WishlistPage";
import Layout from "./components/Layout";
import HomePage from "./pages/HomePage";

function App() {
  return (
    <BrowserRouter>
      <RouteScrollToTop />
      <PhosphorIconInit />
      <Layout>
        <Routes>
          <Route exact path='/' element={<HomePage />} />
          <Route exact path='/shop' element={<ShopPage />} />
          <Route exact path='/product/category/:id' element={<ShopPage />} />
          <Route exact path='/product-details' element={<ProductDetailsPageOne />} />
          <Route exact path='/product-details-two/:slug' element={<ProductDetailsPageTwo />} />
          <Route exact path='/cart' element={<CartPage />} />
          <Route exact path='/checkout' element={<CheckoutPage />} />
          {/* <Route exact path='/become-seller' element={<BecomeSellerPage />} /> */}
          <Route exact path='/wishlist' element={<WishlistPage />} />
          <Route exact path='/login' element={<AccountPage />} />
          <Route exact path='/blog' element={<BlogPage />} />
          <Route exact path='/blog-details' element={<BlogDetailsPage />} />
          <Route exact path='/contact' element={<ContactPage />} />
          {/* <Route exact path='/vendor' element={<VendorPage />} />
          <Route exact path='/vendor-details' element={<VendorDetailsPage />} />
          <Route exact path='/vendor-two' element={<VendorTwoPage />} />
          <Route exact path='/vendor-two-details' element={<VendorTwoDetailsPage />} /> */}
        </Routes>
      </Layout>
    </BrowserRouter>
  );
}

export default App;
